import React from "react";
import { CodeBracketIcon, CloudIcon } from "@heroicons/react/24/outline";

const skills = [
  { name: "Angular (standalone) / Material", icon: CodeBracketIcon },
  { name: "HTML5 / CSS3 / SCSS", icon: CodeBracketIcon },
  { name: "TypeScript", icon: CodeBracketIcon },
  { name: "Tailwind CSS / Responsive", icon: CodeBracketIcon },
  { name: "Python (Flask / FastAPI)", icon: CodeBracketIcon },
  { name: "AWS Lambda / Serverless", icon: CloudIcon },
  { name: "SonarCloud / Seguridad", icon: CodeBracketIcon },
  { name: "APIs REST / Documentación", icon: CodeBracketIcon },
];

const Skills = () => {
  return (
    <section id="skills" aria-label="Habilidades" className="relative py-20">
      <div className="absolute inset-0 bg-gradient-to-br from-[#f6f7f4] via-white to-[#eef2ee]" />

      <div className="relative max-w-6xl mx-auto px-4">
        <div className="mb-10">
          <h2 className="font-poppins text-3xl font-semibold tracking-tight text-slate-900">
            Habilidades
          </h2>
          <p className="mt-3 max-w-2xl text-slate-600">
            Tecnologías y herramientas con las que construyo productos web
            escalables, accesibles y orientados a la experiencia del usuario.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
          {skills.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                role="button"
                tabIndex={0}
                aria-label={s.name}
                title={s.name}
                className="group rounded-2xl border border-[#3f5232]/15 bg-white/70 p-5 backdrop-blur shadow-sm
                           transition hover:-translate-y-1 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#3f5232]/30"
              >
                <div className="flex items-start gap-4">
                  <div
                    className="rounded-xl border border-[#3f5232]/15 bg-[#f4f6f1] p-3 text-[#3f5232]
                               transition group-hover:border-[#3f5232]/25"
                    aria-hidden="true"
                  >
                    <Icon className="h-6 w-6" />
                  </div>

                  <div className="min-w-0">
                    <div className="text-base font-semibold text-slate-900 group-hover:text-[#3f5232] transition">
                      {s.name}
                    </div>
                    <div className="mt-1 text-sm text-slate-600">
                      Experiencia práctica en proyectos reales y despliegues.
                    </div>
                  </div>
                </div>

                <div className="mt-4 h-px w-full bg-gradient-to-r from-[#3f5232]/20 via-slate-200/70 to-transparent" />

                <div className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-[#3f5232]">
                  Ver enfoque
                  <span className="transition group-hover:translate-x-1">→</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
